module.exports = __webpack_public_path__ + "static/media/leaf-fill.bca14e0e.svg";